import { Component, OnInit,ViewChild } from '@angular/core';
import { Router,ActivatedRoute,NavigationStart} from '@angular/router';
import { ReferenceLibraryService } from 'reference-library';
import { HelpVideoOverlayComponent } from 'src/app/modules/shared/help-video-overlay/help-video-overlay.component';

@Component({
  selector: 'app-compliance',
  templateUrl: './compliance.component.html',
  styleUrls: ['./compliance.component.scss']
})
export class ComplianceComponent implements OnInit {
  userType: string;
  @ViewChild(HelpVideoOverlayComponent, { static: false }) helpVideoComponent: HelpVideoOverlayComponent;

  constructor(private router: Router,  private referenceLibraryService: ReferenceLibraryService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  ngAfterViewInit() {
    this.translet();
    this.helpVideoComponent.setTabValues(
      "right",
      "Compliance",
      "Compliance Public and Private Access File",
      "Compliance Public and Private Access File",
      "right",
      "FDNS Details",
      "FDNS Details"
    );
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }

}
